import { Injectable } from '@angular/core';
import { BlueyonderUser } from './blueyonder-user.model';
import { BlueyonderCountry } from './blueyonder-user-country.model';
import { blueyonderCountries } from './blueyonder-countries'
import { BlueyonderUserSearchCriteriaModel } from './blueyonder-user-search-criteria.model';
import { SearchObjectResult } from 'app/shared/search-object-result.model';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { URL_BASE } from 'app/core/constants';
import { HttpUtils } from 'app/shared/http-utils';
import { BlueyonderLogisticGroup } from './blueyonder-logistic-group.model';


@Injectable({
  providedIn: 'root'
})
export class BlueyonderUserService {

  private BLUEYONDER_USER_URI         = 'blueyonder';
  private BLUEYONDER_USERS            = 'users';
  private BLUEYONDER_MY_CARRIER_USERS = 'my-carrier-users';

  constructor(private http: HttpClient) {
  }

  public resetBlueyonderUser(criteria: BlueyonderUserSearchCriteriaModel, canSeeAllCarriers: boolean): any {
    const url     = `${URL_BASE}/api/${this.BLUEYONDER_USER_URI}/users/password-reset`;
    const headers = HttpUtils.createHeaders();
    const params  = {
      forUserCode: criteria.userCode,
      forCarrierId: canSeeAllCarriers ? criteria.carrierId : null
    };

    return this.http.post(url, null, { headers, params });
  }

  public deleteBlueyonderUser(criteria: BlueyonderUserSearchCriteriaModel, canSeeAllCarriers: boolean): any {
    const url     = `${URL_BASE}/api/${this.BLUEYONDER_USER_URI}/users`;
    const headers = HttpUtils.createHeaders();
    const params  = {
      forUserCode: criteria.userCode,
      forCarrierId: canSeeAllCarriers ? criteria.carrierId : null
    };

    return this.http.delete(url, { headers, params });
  }

  public create(blueyonderUser: BlueyonderUser, carrierId: string, canSeeAllCarriers: boolean): any {
    const url     = `${URL_BASE}/api/${this.BLUEYONDER_USER_URI}/${canSeeAllCarriers ? `users?forCarrierId=${carrierId}` : 'my-carrier-users'}`;
    const headers = HttpUtils.createHeaders();

    return this.http.post(url, blueyonderUser.toDto(), { headers })
  }

  public search(
    page: number, size: number, criteria: BlueyonderUserSearchCriteriaModel, canSeeAllCarriers: boolean
  ): Observable<SearchObjectResult<BlueyonderUser>> {
    const url     = `${URL_BASE}/api/${this.BLUEYONDER_USER_URI}/${canSeeAllCarriers ? this.BLUEYONDER_USERS : this.BLUEYONDER_MY_CARRIER_USERS}`;
    const headers = HttpUtils.createHeaders();
    const params  = {
      page: String(page),
      pageSize: String(size),
      forUserCode: criteria.userCode,
      forCarrierId: criteria.carrierId
    };

    for (const key of Object.keys(params)) {
      if (!params[key]) {
        delete params[key];
      }
    }

    return this.http.get(url, { headers, params })
      .pipe(map(result => SearchObjectResult.fromDto(result, BlueyonderUser.fromDto)));
  }

  public getLogisticGroup(): Observable<BlueyonderLogisticGroup[]> {
    const url     = `${URL_BASE}/api/${this.BLUEYONDER_USER_URI}/logistic-groups?langCode=en_us`;
    const headers = HttpUtils.createHeaders();

    return this.http.get(url, { headers })
      .pipe(map((byLogisticGroups: any[]) => byLogisticGroups.map(p => BlueyonderLogisticGroup.fromDto(p))));
  }

  public doBlueyonderUserExist(userCode: string): Observable<any> {
    const url     = `${URL_BASE}/api/${this.BLUEYONDER_USER_URI}/users/exists?userCode=${userCode}`;
    const headers = HttpUtils.createHeaders();

    return this.http.get(url, { headers });
  }

  public getCountries(): Observable<BlueyonderCountry[]> {
    return of(blueyonderCountries.sort((a, b) => a.countryName.localeCompare(b.countryName)));
  }
}

